import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { LevelInterface } from '../+models';

export const LEVEL_SERVICE_TOKEN = new InjectionToken('LevelService');

export interface LevelServiceInterface {
  getAll(): Observable<LevelInterface[]>;
}
